import { DeliveryTypeEnum } from "@saleor/types/globalTypes";

import { LocationRateRowObject } from "./LocationRate";

export const LOCATION_RATE_DELIVERY_OPTIONS = [
  {
    label: "Express Delivery",
    max: "5.00",
    min: "0.00",
    value: DeliveryTypeEnum.EXPRESS
  },
  {
    label: "Express-Long Distance Delivery",
    max: "10.00",
    min: "5.01",
    value: DeliveryTypeEnum.EXPRESS_LONG_DISTANCE
  },
  {
    label: "Same Day Delivery",
    max: "10.00",
    min: "0.00",
    value: DeliveryTypeEnum.SAME_DAY
  }
];

export enum LOCATION_RATE_ERROR_MESSAGE {
  MAX_LESS_MIN = "Maximum distance must not be less than the minimum distance.",
  MAX_EQUAL_MIN = "Maximum distance must not be the same as minimum distance.",
  MAX_NOT_APPLICABLE = "Maximum distance is not applicable for this delivery type.",
  MIN_MAX_NON_NEGATIVE = "Min/Max distance must be a non-negative value.",
  FEE_NON_NEGATIVE = "Delivery fee must be a non-negative value."
}

export const validateLocationRateMax = (
  row: LocationRateRowObject,
  setRows: (value: React.SetStateAction<LocationRateRowObject[]>) => void,
  maxForDelType: number,
  formattedValue: string
) => {
  const rowMin = parseFloat(row.min);
  const rowMax = parseFloat(row.max);
  const needToFormatValue = row.max !== formattedValue;

  if (row.max.length === 0) {
    setRows(prevRows =>
      prevRows.map(r =>
        r.index === row.index
          ? {
              ...r,
              max: "0.00"
            }
          : r
      )
    );
  } else if (rowMin > rowMax) {
    setRows(prevRows =>
      prevRows.map(r =>
        r.index === row.index
          ? {
              ...r,
              max: needToFormatValue ? formattedValue : r.max,
              maxError: LOCATION_RATE_ERROR_MESSAGE.MAX_LESS_MIN
            }
          : r
      )
    );
    return false;
  } else if (rowMin === rowMax) {
    setRows(prevRows =>
      prevRows.map(r =>
        r.index === row.index
          ? {
              ...r,
              max: needToFormatValue ? formattedValue : r.max,
              maxError: LOCATION_RATE_ERROR_MESSAGE.MAX_EQUAL_MIN
            }
          : r
      )
    );
    return false;
  } else if (maxForDelType && rowMax > maxForDelType) {
    setRows(prevRows =>
      prevRows.map(r =>
        r.index === row.index
          ? {
              ...r,
              max: needToFormatValue ? formattedValue : r.max,
              maxError: LOCATION_RATE_ERROR_MESSAGE.MAX_NOT_APPLICABLE
            }
          : r
      )
    );
    return false;
  } else if (!!row.maxError) {
    setRows(prevRows =>
      prevRows.map(r =>
        r.index === row.index
          ? {
              ...r,
              max: needToFormatValue ? formattedValue : r.max,
              maxError: ""
            }
          : r
      )
    );
  } else if (needToFormatValue) {
    setRows(prevRows =>
      prevRows.map(r =>
        r.index === row.index ? { ...r, max: formattedValue } : r
      )
    );
  }
  return true;
};

export const validateLocationRateMin = (
  row: LocationRateRowObject,
  setRows: (value: React.SetStateAction<LocationRateRowObject[]>) => void,
  formattedValue: string
) => {
  const needToFormatValue = row.min !== formattedValue;

  if (row.min.length === 0) {
    setRows(prevRows =>
      prevRows.map(r =>
        r.index === row.index
          ? {
              ...r,
              min: "0.00"
            }
          : r
      )
    );
  } else if (!!row.minError) {
    setRows(prevRows =>
      prevRows.map(r =>
        r.index === row.index
          ? {
              ...r,
              min: needToFormatValue ? formattedValue : r.min,
              minError: ""
            }
          : r
      )
    );
  } else if (needToFormatValue) {
    setRows(prevRows =>
      prevRows.map(r =>
        r.index === row.index ? { ...r, min: formattedValue } : r
      )
    );
  }
};

export const validateLocationRateFee = (
  row: LocationRateRowObject,
  setRows: (value: React.SetStateAction<LocationRateRowObject[]>) => void,
  formattedValue: string
) => {
  const needToFormatValue = row.price !== formattedValue;

  if (row.price.length === 0) {
    setRows(prevRows =>
      prevRows.map(r =>
        r.index === row.index
          ? {
              ...r,
              price: "0.00"
            }
          : r
      )
    );
  } else if (!!row.feeError) {
    setRows(prevRows =>
      prevRows.map(r =>
        r.index === row.index
          ? {
              ...r,
              feeError: "",
              price: needToFormatValue ? formattedValue : r.price
            }
          : r
      )
    );
  } else if (needToFormatValue) {
    setRows(prevRows =>
      prevRows.map(r =>
        r.index === row.index ? { ...r, price: formattedValue } : r
      )
    );
  }
};
